<template>
  <section :id="'timeline-section-' + item.blockId" class="timeline-anchor">
  </section>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'

export default {
  name: 'TimelineAnchor',
  // eslint-disable-next-line vue/require-prop-types
  props: ['item', 'pagePosition', 'siblings-components'],
  mixins: [ReadyHook],
  data () {
    return { }
  }
}
</script>
<style lang="scss" scoped>
@import '~theme/css/core';

.timeline-anchor {
  visibility: hidden;
  overflow: hidden;
  height: 0;
  width: 0;
}
</style>
